import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Typography, FormControl, FormControlLabel, RadioGroup, Radio, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { introduceSchema } from '../../../constants/schemas';
import Input from '../../common/input';
import { Button } from '@material-ui/core';
import Section from '../../common/section';
import { COLORS } from '../../../constants/colors';
import useFetch from '../../../hooks/useFetch';
import { fetchAvailabilities } from '../../../api/availability';
import Searcher from '../../../components/role/searcher';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouteMatch } from 'react-router-dom';

const useStyles = makeStyles({
  main: {
    height: '30.1875rem',
    padding: '1.25rem',
    paddingLeft: '0',
    '& h1, & h2': {
      textTransform: 'uppercase',
      marginBottom: '0.3125rem',
    },
  },
  title: {
    fontSize: '3.125rem',
    fontWeight: 'bold',
    lineHeight: '3.6875rem',
  },
  subtitle: {
    fontSize: '1.5rem',
  },
  description: {
    fontSize: '1rem',
    lineHeight: '1.1875rem',
    marginBottom: '0.3125rem',
  },
  github: {
    color: COLORS.grayScale[5],
  },
  video: {
    height: '23.1875rem',
    width: '100%',
    border: 'none',
    borderRadius: '0.3125rem',
  },
});

const IntroduceForm = ({
  firstName,
  lastName,
  role: initialRole,
  city,
  country,
  availability: initialAvailability,
  github,
  online,
  video,
  onSubmit,
  updatedAt
}) => {
  const isEditing = useRouteMatch({
    path: '/candidates/:hash/edit',
    exact: true,
  });
  const [candidateVideo, setCandidateVideo] = useState('');
  useEffect(() => {
    if(video && video.includes('watch?v=')) {
      const videoUrl = video.replace('watch?v=', 'embed/');
      setCandidateVideo(videoUrl);
    } else {
      setCandidateVideo(video);
    }
  }, [video]);

  const { control, errors, handleSubmit, setValue,  formState: {} } = useForm({
    resolver: yupResolver(introduceSchema)
  });

  const classes = useStyles();
  const [availability, setAvailability] = useState(initialAvailability);
  const [roleAC, setRoleAC] = useState(initialRole?initialRole:null);
  const { result: availabilities } = useFetch(fetchAvailabilities, null, []);

useEffect(() => {
  if (!availability && availabilities?.length > 0) {
      setAvailability(availabilities[0]);
    }
  }, [ availability, availabilities ]);

return (
    <Section>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Grid
              className={classes.main}
              container
              direction="column"
              justify="space-between"
            >
              <Grid item xs md>
                <Typography className={classes.subtitle} variant="subtitle1">
                  Personal information
                </Typography>
                <Controller
                  control={control}
                  name="firstName"
                  defaultValue={firstName}
                  render={({ onChange, onBlur, value }) => (
                    <Input
                      className={classes.title}
                      variant="h1"
                      rows={15}
                      placeholder="First name"
                      value={value}
                      onChange={onChange}
                      onBlur={isEditing && handleSubmit(onSubmit)}
                      invalid={errors && errors.firstName}
                      message={errors && errors.firstName && errors.firstName.message}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="lastName"
                  defaultValue={lastName}
                  render={({ onChange, onBlur, value }) => (
                    <Input
                      className={classes.title}
                      variant="h1"
                      rows={15}
                      placeholder="Last name"
                      value={value}
                      onChange={onChange}
                      onBlur={isEditing && handleSubmit(onSubmit)}
                      invalid={errors && errors.lastName}
                      message={errors && errors.lastName && errors.lastName.message}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="role"
                  defaultValue={roleAC}
                  render={({ onChange, onBlur, value }) => (
                    <div className={classes.searcher}>
                      <Searcher 
                        value={value}
                        startIcon={<FontAwesomeIcon icon={faSearch} />}
                        invalid={errors && errors.role}
                        message={errors && errors.role && errors.role.message}
                        onBlur={isEditing && handleSubmit(onSubmit)}
                        onSelect={(val)=>{
                          setRoleAC(val?val:null); 
                          setValue('role', val?val:"")
                        }} 
                      />
                    </div>
                  )}
                />
                <Grid item>
                  <Controller
                    control={control}
                    name="city"
                    defaultValue={city}
                    render={({ onChange, onBlur, value }) => (
                      <Input
                        className={classes.description}
                        variant="subtitle1"
                        placeholder="City"
                        value={value}
                        onChange={onChange}
                        onBlur={isEditing && handleSubmit(onSubmit)}
                        invalid={errors && errors.city}
                        message={errors && errors.city && errors.city.message} 
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="country"
                    defaultValue={country}
                    render={({ onChange, onBlur, value }) => (
                      <Input
                        className={classes.description}
                        variant="subtitle1"
                        placeholder="Country"
                        value={value}
                        onChange={onChange}
                        onBlur={isEditing && handleSubmit(onSubmit)}
                        invalid={errors && errors.country}
                        message={errors && errors.country && errors.country.message} 
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="github"
                    defaultValue={github}
                    render={({ onChange, onBlur, value }) => (
                      <Input
                        className={classes.description}
                        variant="subtitle1"
                        placeholder="github"
                        value={value}
                        onChange={onChange}
                        onBlur={isEditing && handleSubmit(onSubmit)}
                        invalid={errors && errors.github}
                        message={errors && errors.github && errors.github.message} 
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="online"
                    defaultValue={online}
                    render={({ onChange, onBlur, value }) => (
                      <Input
                        className={classes.description}
                        variant="subtitle1"
                        placeholder="web"
                        value={value}
                        onChange={onChange}
                        onBlur={isEditing && handleSubmit(onSubmit)}
                        invalid={errors && errors.online}
                        message={errors && errors.online && errors.online.message} 
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid
              className={classes.main}
              container
              direction="column"
            >
              <Grid item xs md>
                <Typography className={classes.subtitle} variant="subtitle1">
                  Summary video url
                </Typography>
                <Controller
                  control={control}
                  name="video"
                  defaultValue={video}
                  render={({ onChange, onBlur, value }) => (
                    <Input
                      className={classes.description}
                      variant="subtitle1"
                      placeholder="Paste a youtube or vimeo url"
                      value={value}
                      onChange={onChange}
                      onBlur={isEditing && handleSubmit(onSubmit)}
                      invalid={errors && errors.video}
                      message={errors && errors.video && errors.video.message}
                    />
                  )}
                />
                {candidateVideo && (
                  <iframe
                    className={classes.video}
                    src={candidateVideo}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Candidate presentation"
                    loading="lazy"
                  ></iframe>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid
              className={classes.main}
              container
              direction="column"
              justify="space-between"
            >
            { availabilities && <Grid container item direction="column" xs md>
                <Grid item>
                  <Typography className={classes.subtitle} variant="subtitle1">
                    Availability
                  </Typography>
                </Grid>
                <Grid item>
                  <Controller
                    control={control}
                    name="availability"
                    defaultValue={availability.hash 
                                    ? availability.hash 
                                    : availability.description 
                                        ? availabilities.find(item => item.description === availability.description).hash
                                        : availabilities[0].hash
                    }
                    render={({ onChange, onBlur, value }) => (
                      <FormControl component="fieldset">
                        <RadioGroup row aria-label="availability" name="availability"
                          value={value}
                          onChange={(e) => {
                            setAvailability(availabilities.find(item => item.hash === e.target.value));
                            //onChange(availabilities.find(item => item.hash === e.target.value).hash)
                            onChange(e.target.value)
                          }}
                          onBlur={isEditing && handleSubmit(onSubmit)}
                        >
                          {availabilities?.map((option, index) => {
                            return (
                              <FormControlLabel
                                key={option.hash}
                                value={option.hash}
                                control={<Radio color="primary" />}
                                label={option.description}
                                labelPlacement="start"
                              />
                            )
                          })}
                        </RadioGroup>
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
              }
            </Grid>
          </Grid>
          <Grid item xs md>
            <Typography className={classes.subtitle} variant="subtitle1">
              Last update: {updatedAt && updatedAt.slice(0, 10)}
            </Typography>
          </Grid>
          {!isEditing && (<Grid item xs={12} md={12}  style={{ textAlign: 'right' }}>
            <Button variant="contained" style={{ marginTop: '1em', marginRight: '2em' }} color="primary" onClick={handleSubmit(onSubmit)}>
              SAVE AND CONTINUE
            </Button>
          </Grid>)}
        </Grid>
      </form>
    </Section>
  );
};

IntroduceForm.defaultProps = {
  firstName: '',
  lastName: '',
  role: null,
  city: '',
  country: '',
  availability: '',
  github: '',
  online: '',
  video: '', 
};

IntroduceForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default IntroduceForm;
